// ArtifactDetails.tsx — an artifact's stored facts and its uploader's
// free-form metadata, as a transparent two-column table plus the raw JSON.
import { utils } from 'common';
import type { Artifact } from '../api';

export default function ArtifactDetails({ artifact }: { artifact: Artifact }) {
  const meta = artifact.metadata && Object.keys(artifact.metadata).length > 0 ? artifact.metadata : null;
  const rows: [string, string][] = [
    ['name', artifact.name],
    ['type', artifact.mime_type],
    ['size', utils.formatBytes(artifact.size)],
    ['sha256', artifact.sha256],
    ['experiment', artifact.experiment],
    ['target', artifact.target],
    ['uploaded by', artifact.uploaded_by],
    ['uploaded', new Date(artifact.created_at).toLocaleString()],
  ];
  return (
    <div>
      <table className="table table-sm mb-2">
        <tbody>
          {rows.filter(([, v]) => v).map(([k, v]) => (
            <tr key={k}>
              <th className="text-secondary fw-normal" style={{ width: '9rem' }}>{k}</th>
              <td style={{ wordBreak: 'break-all' }}><code>{v}</code></td>
            </tr>
          ))}
        </tbody>
      </table>
      {meta && (
        <pre className="mb-0" style={{ maxHeight: '16rem', overflow: 'auto' }}>
          {JSON.stringify(meta, null, 2)}
        </pre>
      )}
    </div>
  );
}
